import keyMirror from 'keymirror';

export const ActionTypes = keyMirror({
  INITIALIZE: null,
  RESET_TO_INITIAL: null,
  CHANGE_NPID: null,
  CHANGE_NEGETIVE_NPID: null,
  CHANGE_MULTIPLY_CLICKS: null,
  START_VIDEO_PLAY: null,
  STOP_VIDEO_PLAY: null,
  CHARITY_SELECTED: null,
  CHARITY_UNSELECTED: null,
  CHARITY_INFO_SELECTED: null,
  CLOSE_POPOVER: null,
  SEE_MORE: null,
  CHARITY_NEARBY_SELECTED: null,
  CHARITY_NEARBY_UNSELECTED: null,
  CHARITY_NEARBY_INFO_SELECTED: null,
  CLOSE_NEARBY_POPOVER: null,
  SEE_NEARBY_MORE: null,
});
